import type React from 'react';
import { FixedSizeList } from 'react-window';

import cn from '../../../../utils/cn';
import DropdownBodyPlaceholder from '../DropdownBodyPlaceholder';

export interface DropdownListProps<T> {
  heightList?: number;
  heightItem?: number;
  data: T[];
  isLoading?: boolean;
  className?: string;
  loadingComponent?: React.ReactNode;
  placeholderComponent?: React.ReactNode;
  itemComponent: (item: T, index: number) => React.ReactNode;
}

const DropdownList = <T,>({
  heightList = 300,
  heightItem = 24,
  data,
  isLoading = false,
  className,
  loadingComponent: Loading,
  placeholderComponent: Placeholder,
  itemComponent: ItemList,
}: DropdownListProps<T>) => {
  const itemCount = data?.length;

  if (isLoading) return <>{Loading || 'Carregando...'}</>;
  if (!itemCount)
    return Placeholder ? <>{Placeholder}</> : <DropdownBodyPlaceholder />;

  const Row = ({ index, style }: { index: number; style: any }) => {
    const item = data[index];
    return <div style={style}>{ItemList(item, index)}</div>;
  };

  return (
    <FixedSizeList
      className={cn('scrollBar', className)}
      itemCount={itemCount}
      height={heightList}
      itemSize={heightItem}
      width='100% z-10'
    >
      {Row}
    </FixedSizeList>
  );
};

export default DropdownList;
